// Please refer authentication.md for details on how this works
import {storage} from '../services/config/storage';
import CryptoJS from 'crypto-js';
import GlobalApi from '../services/Global';

const AES = CryptoJS.AES;

export const encryptData = (data, key) => {
    return AES.encrypt(data, key).toString();
};

export const decryptData = (data, key) => {
    return AES.decrypt(data, key).toString(CryptoJS.enc.Utf8);
};

export const isTermsAccepted = () => {
    if (
        storage.fetch.userDetails()?.userProps?.termAccepted === '1' ||
        storage.fetch.userDetails()?.userProps?.usTermAccepted === '1'
    )
        return '1';
    return '0';
};
export const doesUserHasAccess = async (condition, entityId, entityType) => {
    // if (condition) {
    //     /**
    //      * Acc to API Status:1 means has access
    //      * */
    //     try {
    //         let res = await GlobalApi.checkUserAccess({entityId, entityType});
    //         return res?.status === 1;
    //     } catch (e) {
    //         return undefined;
    //     }
    // } else return true;
    return true;
};
